import AboutUs from '../../components/AboutUs/AboutUs';
import Accordion from '../../components/Accordion/Accordion';
import BreadcrumbsComp from '../../components/Breadcrumbs/Breadcrumbs';
import ContactAd from '../../components/Contact/ContactAd';
import styles from '../../styles/Ad.module.scss';
import downloadStyles from '../../styles/DownloadDocs.module.scss';
import content from '../../utils/adContent.js';
import Player from '../../components/player/Player';

const Reklama = () => {
  const typo = [{ url: '/', name: 'Strona główna' }, { name: 'reklama' }];

  return (
    <>
      <div className={styles.wrapper}>
        <BreadcrumbsComp mainPage={false} typo={typo} />
        <ContactAd />
        <div className={styles.accordionContainer}>
          {content.map((el, idx) => (
            <Accordion header={el.header} image={el.img} key={'ad-' + idx}>
              <div className={styles.insideContainer}>
                <p className={styles.text}>{el.text}</p>
                {el.docs && (
                  <div className={downloadStyles.insideDownload}>
                    <img
                      src='/download.svg'
                      className={downloadStyles.downloadIcon}
                    />
                    <a
                      href={el.docs.file}
                      target='_blank'
                      rel='noopener noreferrer'
                      className={downloadStyles.downloadLink}
                    >
                      {el.docs.text}
                    </a>
                  </div>
                )}
              </div>
            </Accordion>
          ))}
          <Accordion header={'Nasz showreel'} image={'/showreel.png'}>
            <div className={styles.insideContainer}>
              <Player
                url={
                  'http://data.tvtoya.pl/toyatv/multimedia/showreel/TOYA_showreel_dtv.mp4'
                }
              />
            </div>
          </Accordion>
        </div>
      </div>
      <AboutUs />
    </>
  );
};

export async function getServerSideProps(context) {
  let prevPath = null;
  let clicked = null;
  if (context.req.headers.referer) {
    prevPath = context.req.headers.referer;
  }
  if (context.query.clicked >= 0) {
    clicked = parseInt(context.query.clicked);
  }

  return {
    props: {
      path: prevPath,
      clicked: clicked,
    },
  };
}

export default Reklama;
